import React from 'react'

const SortBy = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14.25" width="14px" height="14px">
    <defs />
    <g transform="translate(0 0.25)">
      <rect className="a" width="14" height="14" fill="none" />
      <path
        className="b"
        d="M3.4,13.156V1.19l2.1,2.1A.35.35,0,0,0,6,2.8L3.3.1A.359.359,0,0,0,2.8.1L.1,2.8A.349.349,0,0,0,.6,3.293l2.1-2.1V13.156a.35.35,0,1,0,.7,0Z"
        transform="translate(4)"
        stroke="#000000"
        strokeMiterlimit="10"
        strokeWidth="0.5px"
      />
    </g>
  </svg>
)

export default SortBy
